import React, { useRef } from 'react';
import { useToast } from '../../ToastProvider';
import copy from 'copy-to-clipboard';

interface RapsInfoProps {
    name: string;
    value: string;
    class: string;
    uom: string;
}

export function RapsInfoElement(props: RapsInfoProps) {
    const nameRef = useRef<HTMLDivElement>(null);
    const valueRef = useRef<HTMLDivElement>(null);
    const { showToast } = useToast();

    const isOverflowing = (element: HTMLDivElement | null): boolean => {
        return element ? element.scrollWidth > element.clientWidth : false;
    };

    const handleOverflowClick = (ref: React.RefObject<HTMLDivElement>, content: string) => {
        copy(content, {
            debug: false,
            message: 'Press #{key} to copy',
        });
        showToast({ title: 'Copied to clipboard', intent: 'success', body: content });
    };

    const normalizedValue = props.value.replace(',', '.');
    const isNumeric = /^[+-]?\d+(\.\d+)?$/.test(normalizedValue);

    const roundedValue = isNumeric
        ? Number.isInteger(parseFloat(normalizedValue))
            ? normalizedValue
            : parseFloat(normalizedValue).toFixed(3)
        : props.value;

    return (
        <div className={`flex flex-col gap-1  max-w-sm ${props.class} table-auto`}>
            <div
                ref={nameRef}
                className="font-bold overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer"
                title={props.name}
                onClick={() => handleOverflowClick(nameRef, props.name + ": " + roundedValue)}
            >
                {props.name}
            </div>

            <div
                ref={valueRef}
                className="font-base overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer"
                title={props.value}
                onClick={() => handleOverflowClick(valueRef, props.name + ": " + roundedValue)}
            >
                {roundedValue} {props.uom}
            </div>
        </div>
    );
}
